module.exports = __webpack_public_path__ + "frontend/img/icon_close_back.b8e65ebf.svg";